module.exports = __webpack_public_path__ + "static/major-tom-agency-k-8-lpw-m-xc-as-unsplash3x-fa80de016fe4bed6865305f2fe62a9ac.png";